<template>
  <div class="body-width" >
    <div class="div-row div-pad-top news-Medium-24" >
      智能船岸基控制中心
    </div>
    <div class="div-row" style="padding-left: 20px">
      <p class="indentation">智能船岸基控制中心具有如下功能：岸基信息支持、智能船舶可视化远程交互与控制、智能货物管理、船舶航行远程智能决策等功能</p>
    </div>
    <div>
        <div class= "function_detail" align="left">
          <span class="news-Medium-18">岸基信息支持</span>
          <ul>
             <li><span>航路气象及海况信息 </span></li>
             <li><span>海事安全信息 </span></li>
             <li><span>航路优化信息 </span></li>
             <li><span>货物配载信息 </span></li>
             <li><span>远程智能决策信息 </span></li>
             <li><span>遥测遥控信息 </span></li>
          </ul>
        </div>
        <div class="function_img" align="right">
          <img src="../../../../assets/images/productcenter/zncy/zncajzx/1.png">
        </div>
    </div>
    <div class="function">
      <div class= "function_detail" align="left">
        <span class="news-Medium-18">智能船舶可视化远程交互与控制</span>
        <ul>
           <li><span>场景远程感知和混合现实（MR）呈现 </span></li>
           <li><span>船舶多源数据信息融合与呈现 </span></li>
           <li><span>智能船舶船桥远程遥控操作 </span></li>
           <li><span>智能船舶主推进远程遥控操作 </span></li>
        </ul>
      </div>
      <div class="function_img" align="right">
        <img src="../../../../assets/images/productcenter/zncy/zncajzx/2.png">
      </div>
    </div>
    <div class="function">
      <div class= "function_detail" align="left">
        <span class="news-Medium-18">智能货物管理</span>
        <ul>
           <li><span>基于船舶三维设计数据的智能配载 </span></li>
           <li><span>基于纵倾优化的船舶最佳配载 </span></li>
           <li><span>配载计算校核和优化配载方案自动输出 </span></li>
           <li><span>集装箱、件杂货、危险品等智能监测和管理 </span></li>
        </ul>
      </div>
      <div class="function_img" align="right">
        <img src="../../../../assets/images/productcenter/zncy/zncajzx/3.png">
      </div>
    </div>
    <div class="function">
      <div class= "function_detail" align="left">
        <span class="news-Medium-18">智能航行远程智能决策</span>
        <ul>
           <li><span>场景感知信息和船舶状态信息的综合分析决策 </span></li>
           <li><span>基于避碰规则的复杂水域船舶自动避碰辅助决策 </span></li>
           <li><span>航行智能设计和优化 </span></li>
           <li><span>自动靠离泊远程辅助决策 </span></li>
           <li><span>船舶航向和航迹智能控制 </span></li>
           <li><span>能效管理辅助决策 </span></li>
           <li><span>基于航次计划的航速变化 </span></li>
        </ul>
      </div>
      <div class="function_img" align="right">
        <img src="../../../../assets/images/productcenter/zncy/zncajzx/4.png">
      </div>
    </div>
    <div style="padding-top: 300px">
      <img src="../../../../assets/images/productcenter/zncy/zncajzx/5.png">
      <div class="function_img" align="right">
        <img src="../../../../assets/images/productcenter/zncy/zncajzx/6.png">
      </div>
    </div>
  </div>
</template>

<script>
    export default {
        name: "zncajkzzx"
    }
</script>

<style scoped>
  .div-pad-top {
    padding-top: 50px;
    padding-bottom: 30px;
  }
  .function_detail{
    float: left;
  }
  .function_img{
    float: right;
  }
  .function{
    padding-top: 400px;
  }

  p{
    font-size: 16px;
    color: #666666;
  }
  li{
    color: #2E79BE;
    font-size: 16px;
  }
  li span{
    color: #666666;
  }
</style>



// WEBPACK FOOTER //
// src/components/contentcoms/prodecutcontentcoms/zncyxlcp/zncajkzzx.vue